export const LedStatusColor: { [key: string]: string } = {
  Green: 'haiui-green-01',
  Red: 'haiui-red-01',
  Amber: 'haiui-amber-01',
  Blue: 'haiui-blue-01',
};

export interface GetLocateStatusResponse {
  statusLED: string;
  statusTransitions: number;
  blinkingWillStopIn?: string;
}
